// src/pages/Cookies.jsx
import React from 'react';
import './Cookies.css';
import Hero from '../components/Home/Hero';

export default function Cookies() {
  return (
    <>
      <Hero title="Cookieverklaring" />

      <section className="cookies-page py-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm p-4">
                <h1 className="mb-4">Cookieverklaring</h1>

                <p>
                  Bij <strong>OnlineGrowthClub.nl</strong> maken we gebruik van cookies om jouw ervaring op onze website te verbeteren. In deze cookieverklaring leggen we uit welke cookies we gebruiken, waarom we dat doen, en hoe jij jouw voorkeuren kunt beheren.
                </p>

                <h2 className="mt-5">Wat zijn cookies?</h2>
                <p>
                  Cookies zijn kleine tekstbestanden die door je browser worden opgeslagen wanneer je onze website bezoekt. Ze helpen ons om de site goed te laten werken, statistieken te verzamelen en je een betere en meer persoonlijke ervaring te bieden.
                </p>

                <h2 className="mt-5">Welke cookies gebruiken we?</h2>
                <ul>
                  <li>
                    <strong>Functionele cookies</strong><br />
                    Deze zorgen ervoor dat onze website goed werkt. Ze onthouden bijvoorbeeld je voorkeurstaal of of je een melding hebt gesloten.
                  </li>
                  <li className="mt-3">
                    <strong>Analytische cookies</strong><br />
                    Met behulp van tools zoals Google Analytics meten we hoe bezoekers onze website gebruiken. Deze gegevens helpen ons om de website continu te verbeteren.
                  </li>
                  <li className="mt-3">
                    <strong>Marketing- en trackingcookies</strong><br />
                    Deze cookies worden gebruikt om gepersonaliseerde advertenties te tonen via platforms zoals Google Ads of social media. Zo zorgen we dat je relevante content te zien krijgt.
                  </li>
                </ul>

                <h2 className="mt-5">Cookievoorkeuren beheren</h2>
                <p>
                  Bij je eerste bezoek tonen we een cookiemelding waarin je jouw voorkeuren kunt aangeven. Je kunt deze instellingen op elk moment aanpassen via de knop ‘Cookie-instellingen’ onderaan de pagina.
                </p>

                <h2 className="mt-5">Meer weten?</h2>
                <p>
                  Bekijk ons volledige <a href="/privacy">privacybeleid</a> voor meer informatie over hoe we omgaan met persoonsgegevens en je rechten als gebruiker.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
